import React from 'react';
import { StarIcon } from 'lucide-react';
import { TESTIMONIALS } from '../data/content';
export function Testimonials() {
  return <section className="px-5 py-8" data-id="element-162">
      <div className="mx-auto max-w-xl" data-id="element-163">
        <h2 className="text-center font-display text-2xl font-800 uppercase leading-tight text-white" data-id="element-164">
          Coaches Like You Are Already Using It
        </h2>

        <div className="mt-6 space-y-3" data-id="element-165">
          {TESTIMONIALS.map(t => <figure key={t.name} className="flex items-start gap-3 rounded-2xl border border-white/20 bg-[#101b2d]/95 p-4 shadow-lg shadow-black/20" data-id="element-166">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[var(--pb-lime)]/15 font-display text-lg font-800 text-[var(--pb-lime)]" data-id="element-167">
                {t.name.charAt(0)}
              </div>
              <div className="min-w-0" data-id="element-168">
                <div className="flex gap-0.5" aria-label="5 stars" data-id="element-169">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} size={12} className="fill-yellow-400 text-yellow-400" data-id="element-170" />)}
                </div>
                <blockquote className="mt-1 text-sm leading-snug text-white/85" data-id="element-171">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-1 text-xs text-white/50" data-id="element-172">
                  {t.name}, {t.age} · {t.city}
                </figcaption>
              </div>
            </figure>)}
        </div>
      </div>
    </section>;
}